import {Injectable} from '@angular/core';
import {loaders, LoadingMode} from "../_utils/loader";
import {TranslateService} from "@ngx-translate/core";
import { returnDef } from '../_utils/tools.utils';



@Injectable({providedIn: 'root'})
export class LoadingService {
  public messages: object;
  public loading: boolean
  public count: number
  public message: string
  public title: string
  public value: number = 0;
  public fullBackground: boolean;
  public maxValue: number = 100;
  public requestsCount: number = 0;
  public type: LoadingMode;
  private defTitle: string;
  private defMessage: string;

  constructor(private translate: TranslateService) {
    this.resetLoader();
  }

  public reset() {
    this.loading = false;
    this.fullBackground = false;
    this.title = '';
    this.message = '';
    this.defMessage = this.translate.instant('Load_Data');
    this.defTitle = this.translate.instant('Wait');
    if (this.requestsCount === this.maxValue) {
      this.requestsCount = 0;
      this.value = 0;
    }
  }

  public loadOptions(routes: string, subSegment: string){
    let route = '';
    if (subSegment === 'access' && routes === 'update') {
      route = this.removeCharFromString(subSegment, '/') + routes;
    } else {
      route = this.removeCharFromString(routes, '/');
    }

    let options =  loaders.find(r => r.route === route);

    if (options !== undefined) {
      this.loading = options.options.loading;
      this.fullBackground = returnDef(this.fullBackground, options.options.fullBackground);
      this.type = options.options.type ? options.options.type : this.type
      if (options.options.message !== undefined) {
        this.message = this.translate.instant(options.options.message);
      }
      if (options.options.title !== undefined) {
        this.title = this.translate.instant(options.options.title);
      }
      this.maxValue = options.options.progressRequest ? options.options.progressRequest : this.maxValue
    } else {
      if (subSegment !== 'i18n') {
        this.reset();
        this.title = this.defTitle;
        this.message = this.defMessage;
      } else {
        this.title = '';
        this.message = '';
      }
      this.loading = true;
    }
  }

  public setCount() {
    this.count++;
    if (this.type === 'progressbar') {
      this.requestsCount++;
    }
  }

  public initProgressBar(maxValue: number, nbrequest: number = 1){
    this.reset()
    this.type = 'progressbar'
    this.requestsCount = 0
    maxValue = maxValue * nbrequest
    this.maxValue = maxValue * 2
  }

  public resetLoader() {
    this.type = 'spinner';
    this.requestsCount = 0;
    this.maxValue = 0;
    this.count = 0;
    this.reset()
  }

  private removeCharFromString(input: string, char: string): string {
    return input.replace(new RegExp(char, 'g'), '');
  }

  public calculateProgress (): void {
    if (this.type === 'progressbar') {
        this.requestsCount++
        this.value = Math.floor(this.requestsCount * 100 / this.maxValue);
        if (this.value > 100) {
          this.value = 100;
        }
      }
    }

}
